import axios from "../../../axios"
import { getCurrentTenant, parseObjectParamsToString } from '@/utils'

export default {
  create(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createUserForgot ${parseObjectParamsToString(data)} 
        {
            message
          }
        }
      `
    })
  },
  check(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          checkUserForgot ${parseObjectParamsToString(data)}
        {
          user {
            id,
            name,
            email,
            username,
            role {
                id,
                name
            }
          }
        }
      }
      `
    })
  },
}
